// extracted by mini-css-extract-plugin
module.exports = {"select":"Select__select","blue":"Select__blue","white":"Select__white","fadeIn":"Select__fadeIn"};